import { tryBeginQuickProjectSave, type QuickSaveLock } from './quickSaveGuard';

export interface QuickSavePrerequisites {
  hasResult: boolean;
  reopenBlocked: boolean;
  isAuthenticated: boolean;
  isOnline: boolean;
  lock: QuickSaveLock;
  onMessage: (message: string) => void;
}

export function canStartQuickProjectSave(input: QuickSavePrerequisites): boolean {
  if (!input.hasResult || input.reopenBlocked) return false;
  if (!input.isAuthenticated) {
    input.onMessage('Zaloguj się, aby zapisać projekt i wrócić do niego później.');
    return false;
  }
  if (!input.isOnline) {
    input.onMessage('Ta funkcja wymaga internetu. Robocza wycena została zapisana lokalnie.');
    return false;
  }
  return tryBeginQuickProjectSave(input.lock);
}
